import { useCallback, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../store';

export const useSessionLifecycle = () => {
  const [expirationTime, isSessionAuthenticated, refreshSession] = useStore(
    useShallow((state) => [
      state.session?.getDecodedAuthToken()?.exp,
      state.isSessionAuthenticated(),
      state.refreshSession,
    ])
  );

  const setTimer = useCallback(() => {
    const refreshAuthToken = async () => {
      console.debug('Refreshing auth token.');
      await refreshSession();
    };

    if (!isSessionAuthenticated) {
      return null;
    }

    if (!expirationTime) {
      return null;
    }

    const expiresIn = expirationTime * 1000 - Date.now();
    const timerOffset = Math.min(
      12 * 60 * 60 * 1000,
      expiresIn - 2 * 60 * 1000
    ); // Run timer at least every 12 hours

    return setTimeout(refreshAuthToken, timerOffset);
  }, [expirationTime, isSessionAuthenticated, refreshSession]);

  useEffect(() => {
    const timer = setTimer();

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [setTimer]);
};
